import axios from 'axios'
import { i18n } from '../../../../../plugins/i18n'
export const companiesMapionBizBannersTemplatesCsvImports = {
  namespaced: true,
  state: {
    data: [],
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    importCsv({ commit, rootState }, { templateId, data}) {
      commit('prepareConnect')
      return axios
        .post(`/api/companies/${ rootState.route.params.company_uuid }/oc/mapion_biz/banners/templates/${ templateId }/csv_imports`, data , {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then( () => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.upload', { value: i18n.t('pages.CompaniesTestimonials.csv') }) }, { root: true })
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
  }
}
